module.exports = __webpack_public_path__ + "1.5.0-unryo/img/postgresql.d7c985e7.svg";